export default __webpack_public_path__ + "static/l_team_navi_colored-f6a77487fc8640a0087c2bae4e7ea5c1.svg";